import styled from "styled-components";

export default styled.div`
  width: 50px;
  height: 50px;
  background: #c4c4c4;
`;
